var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full bg-white flex justify-center items-center"},[_vm._v(" "+_vm._s(_vm.$t('general.loading_dots'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }